export default __webpack_public_path__ + "static/23-7c997d503388a871898fd64963090233.gif";